module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.5565",
      "hs-test-utils": "static-1.8151",
      "I18n": "static-7.1641",
      "jasmine-runner": "static-1.6588",
      "quartz": "static-1.7204",
      "hubspot-url-utils": "static-1.4235",
      "outpost": "static-1.4301",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.187",
      "moment": "static-3.26",
      "foundations-components": "static-1.8193",
      "framer-motion": "static-1.73",
      "hs-test-utils-bend-plugin": "static-1.3262",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.73",
      "redux": "static-4.16",
      "testing-library": "static-1.153",
      "enviro": "static-4.468",
      "i18n-data": "static-1.223",
      "metrics-js": "static-1.9770",
      "moment-timezone": "static-5.84",
      "react-utils": "static-2.5440",
      "StyleGuideUI": "static-3.489",
      "jasmine": "static-4.4456",
      "quartz-config": "static-1.982",
      "webpack-env": "static-1.54",
      "quartz-core": "static-1.6423",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.4462",
      "floating-ui": "static-1.58",
      "foundations-assets": "static-1.5005",
      "foundations-theming": "static-1.4564",
      "foundations-theming-specialty": "static-1.2280",
      "hs-story-utils": "static-1.9554",
      "react-aria": "static-1.67",
      "react-create-root-preference": "static-1.39",
      "react-select-plus": "static-1.106",
      "react-virtualized": "static-2.100",
      "styled-components": "static-2.91",
      "tanstack-table": "static-1.56",
      "trellis-assets": "static-1.2216",
      "ui-fonts": "static-1.864",
      "ui-images": "static-2.1189",
      "bender-build-tools": "static-1.3301",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.139",
      "general-store": "static-6.20",
      "HeadJS": "static-2.773",
      "hub-http": "static-1.6353",
      "hub-http-janus": "static-1.848",
      "hubspotter-http": "static-1.4749",
      "icons": "static-2.656",
      "mobile-manifest-mixins": "static-1.547",
      "module-federation": "static-1.27",
      "PortalIdParser": "static-2.417",
      "quartz-auth": "static-1.879",
      "quartz-head": "static-1.869",
      "quartz-i18n": "static-1.879",
      "quartz-routing": "static-1.634",
      "quartz-test": "static-1.879",
      "quartz-tracking": "static-1.583",
      "quick-fetch": "static-1.4016",
      "raven": "static-3.6062",
      "raven-hubspot": "static-1.6369",
      "react-rhumb": "static-1.16816",
      "trellis-components": "static-1.2235",
      "UIComponents": "static-3.8548",
      "usage-tracker-container": "static-1.7472",
      "usage-tracker-core": "static-1.7332",
      "bend-plugin-foundations-theming": "static-1.3047",
      "foundations-theming-base": "static-1.3549",
      "stylex": "static-1.35",
      "classnames": "static-2.10",
      "react-input-autosize": "static-2.17",
      "hs-locale-management": "static-1.179",
      "sassPrefix": "static-1.158",
      "hub-http-shared-msw-handlers": "static-1.10290",
      "hubspotter-http-shared-msw-handlers": "static-1.10288",
      "hs-promise-rejection-tracking": "static-1.5719",
      "usage-tracker-session-replay": "static-1.5168",
      "web-vitals": "static-1.7",
      "base-ui": "static-1.15",
      "react-day-picker": "static-1.4",
      "trellis-theming": "static-1.1075",
      "tanstack-virtual": "static-1.31",
      "cssUtils": "static-1.831",
      "head-dlb": "static-1.5007",
      "HubStyle": "static-2.11909",
      "HubStyleTokens": "static-2.11602",
      "ts-schema": "static-1.4180",
      "amplitude-session-replay-browser": "static-1.60"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.5565",
      "hs-test-utils": "/hs-test-utils/static-1.8151",
      "I18n": "/I18n/static-7.1641",
      "jasmine-runner": "/jasmine-runner/static-1.6588",
      "quartz": "/quartz/static-1.7204",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4235",
      "outpost": "/outpost/static-1.4301",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.187",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.8193",
      "framer-motion": "/framer-motion/static-1.73",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3262",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.73",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.153",
      "enviro": "/enviro/static-4.468",
      "i18n-data": "/i18n-data/static-1.223",
      "metrics-js": "/metrics-js/static-1.9770",
      "moment-timezone": "/moment-timezone/static-5.84",
      "react-utils": "/react-utils/static-2.5440",
      "StyleGuideUI": "/StyleGuideUI/static-3.489",
      "jasmine": "/jasmine/static-4.4456",
      "quartz-config": "/quartz-config/static-1.982",
      "webpack-env": "/webpack-env/static-1.54",
      "quartz-core": "/quartz-core/static-1.6423",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4462",
      "floating-ui": "/floating-ui/static-1.58",
      "foundations-assets": "/foundations-assets/static-1.5005",
      "foundations-theming": "/foundations-theming/static-1.4564",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2280",
      "hs-story-utils": "/hs-story-utils/static-1.9554",
      "react-aria": "/react-aria/static-1.67",
      "react-create-root-preference": "/react-create-root-preference/static-1.39",
      "react-select-plus": "/react-select-plus/static-1.106",
      "react-virtualized": "/react-virtualized/static-2.100",
      "styled-components": "/styled-components/static-2.91",
      "tanstack-table": "/tanstack-table/static-1.56",
      "trellis-assets": "/trellis-assets/static-1.2216",
      "ui-fonts": "/ui-fonts/static-1.864",
      "ui-images": "/ui-images/static-2.1189",
      "bender-build-tools": "/bender-build-tools/static-1.3301",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.139",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.773",
      "hub-http": "/hub-http/static-1.6353",
      "hub-http-janus": "/hub-http-janus/static-1.848",
      "hubspotter-http": "/hubspotter-http/static-1.4749",
      "icons": "/icons/static-2.656",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.547",
      "module-federation": "/module-federation/static-1.27",
      "PortalIdParser": "/PortalIdParser/static-2.417",
      "quartz-auth": "/quartz-auth/static-1.879",
      "quartz-head": "/quartz-head/static-1.869",
      "quartz-i18n": "/quartz-i18n/static-1.879",
      "quartz-routing": "/quartz-routing/static-1.634",
      "quartz-test": "/quartz-test/static-1.879",
      "quartz-tracking": "/quartz-tracking/static-1.583",
      "quick-fetch": "/quick-fetch/static-1.4016",
      "raven": "/raven/static-3.6062",
      "raven-hubspot": "/raven-hubspot/static-1.6369",
      "react-rhumb": "/react-rhumb/static-1.16816",
      "trellis-components": "/trellis-components/static-1.2235",
      "UIComponents": "/UIComponents/static-3.8548",
      "usage-tracker-container": "/usage-tracker-container/static-1.7472",
      "usage-tracker-core": "/usage-tracker-core/static-1.7332",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3047",
      "foundations-theming-base": "/foundations-theming-base/static-1.3549",
      "stylex": "/stylex/static-1.35",
      "classnames": "/classnames/static-2.10",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-locale-management": "/hs-locale-management/static-1.179",
      "sassPrefix": "/sassPrefix/static-1.158",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10290",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10288",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5719",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5168",
      "web-vitals": "/web-vitals/static-1.7",
      "base-ui": "/base-ui/static-1.15",
      "react-day-picker": "/react-day-picker/static-1.4",
      "trellis-theming": "/trellis-theming/static-1.1075",
      "tanstack-virtual": "/tanstack-virtual/static-1.31",
      "cssUtils": "/cssUtils/static-1.831",
      "head-dlb": "/head-dlb/static-1.5007",
      "HubStyle": "/HubStyle/static-2.11909",
      "HubStyleTokens": "/HubStyleTokens/static-2.11602",
      "ts-schema": "/ts-schema/static-1.4180",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
    },
    "bundlingPackage": "feedback-knowledge-js",
    "bundlingPackageVersion": "static-1.5565",
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};